import { create } from "zustand";

const useStore = create((set) => ({
  isAuth: null,
  setIsAuth: (isAuth) => set({ isAuth }),
}));

export default useStore;
